import React from "react";
import { match, NavLink, Redirect, Route, Switch } from "react-router-dom";
import { TabContent, TabPane, Nav, NavItem, NavLink as Link } from "reactstrap";
import classnames from "classnames";

type Props = {
  activeTab: string;
  toggleTab: (id: string) => void;
  navItems: {
    id: string;
    label: string;
  }[];
  tabPanes: {
    id: string;
    content: React.ReactNode;
  }[];
  routeMatch: match<{}>;
};

const NavTabs = ({
  activeTab,
  toggleTab,
  navItems,
  tabPanes,
  routeMatch,
}: Props) => {
  const { url, path } = routeMatch;

  return (
    <React.Fragment>
      <div className="vertical_scroll">
        <Nav tabs>
          {navItems?.map((item, i) => (
            <NavItem key={i} id={item?.label.replace(/\s/g, "-")}>
              <NavLink
                onClick={() => toggleTab(item?.id)}
                to={`${url}/${item?.id}`}
              >
                <Link
                  className={classnames({ active: activeTab === item?.id })}
                >
                  {item?.label}
                </Link>
              </NavLink>
            </NavItem>
          ))}
        </Nav>
      </div>

      <Switch>
        {tabPanes.map((item, i) => (
          <Route
            key={i}
            // exact
            path={`${path}/${item?.id}`}
            render={() => (
              <TabContent activeTab={activeTab}>
                <TabPane tabId={item?.id} id={activeTab}>
                  {item?.content}
                </TabPane>
              </TabContent>
            )}
          />
        ))}
        <Redirect from={path} to={`${url}/${tabPanes?.[0]?.id}`} />
      </Switch>
    </React.Fragment>
  );
};

export default NavTabs;
